import { selectLaunchableJourneyIdsSorted } from '../selectors/config'
import type { JourneySelectAction } from '../types/actions'

import { actionFactory } from './factory'

export const journeySelect = actionFactory<JourneySelectAction>(
  (state, { id }) => {
    const allowedIds = selectLaunchableJourneyIdsSorted(state)

    if (allowedIds.includes(id)) {
      state.selectedJourneyId = id

      // clear contextual state
      state.blockValues = {}
      state.logicsEngine = { history: [], locked: false }
      state.navigatedPath = []
    }
  },
  'journeySelect'
)
